// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","desktopMenu":"_28woa","extraMenu":"_1cRi2","menu":"nblzI","openedMenu":"ohNyi","searchMenu":"_1IQxc"};